import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import common from "./locales/en/common.js";
import components from "./locales/en/components.js";
import forms from "./locales/en/forms.js";
import hooks from "./locales/en/hooks.js";
import layout from "./locales/en/layout.js";
import pages from "./locales/en/pages.js";

// We don't have a requirement to internationalise yet so let's not
// bother loading from backend etc.
// We just want to have the scaffolding in place
const jsonTranslationFiles = {
  ...common,
  ...pages,
  ...forms,
  ...hooks,
  ...layout,
  ...components,
};
export const resources = {
  en: {
    translation: jsonTranslationFiles,
  },
};

void i18n.use(initReactI18next).init({
  lng: "en",
  resources,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes rendered output
  },
});
